import * as yup from 'yup';

const SchemaIndividual = () => {
  const schema = {
    sucursalesSeleccionadas: yup
      .array()
      .min(1, 'Este campo es obligatorio')
      .required('Este campo es obligatorio'),

    negocio: yup.object().required('Este campo es obligatorio')
  };

  return yup.object().shape(schema);
};

export { SchemaIndividual };
